import { getOAuthRedirectUri } from './oauthRedirect';

/**
 * Normalize API/integration errors into user-facing toast messages.
 * Supports handleApi string errors and structured backend errors.
 */
export const getIntegrationErrorMessage = (
  error,
  fallback = 'Something went wrong. Please try again.',
) => {
  if (!error) return fallback;
  if (typeof error === 'string') return error;

  const errorCode = error?.error?.error_code;
  const codeMessages = {
    NETWORK_ERROR:
      'Unable to reach the server. Please check your connection and try again.',
    INVALID_RESPONSE: 'The server returned an unexpected response. Please try again.',
    FACEBOOK_CONFIG_ERROR: 'Facebook OAuth is not configured on the server.',
    INSTAGRAM_CONFIG_ERROR: 'Instagram OAuth is not configured on the server.',
    LINKEDIN_CONFIG_ERROR: 'LinkedIn OAuth is not configured on the server.',
    LINKEDIN_TOKEN_EXCHANGE_FAILED: 'Failed to connect LinkedIn. Please try again.',
    SNAPCHAT_REDIRECT_URI_MISMATCH:
      'Snapchat redirect URL mismatch between frontend and backend.',
    GOOGLE_ADS_NO_ACCOUNT:
      'This Google account does not have a Google Ads account. Sign in with a different Google account, or create one at ads.google.com.',
    SPOTIFY_TOKEN_EXCHANGE_FAILED: 'Failed to connect Spotify. Please try again.',
    INSTAGRAM_TOKEN_EXCHANGE_FAILED: 'Failed to connect Instagram. Please try again.',
  };

  if (errorCode && codeMessages[errorCode]) {
    return codeMessages[errorCode];
  }

  const nestedMessage = error?.error?.error_message;
  if (typeof nestedMessage === 'string' && nestedMessage.trim()) {
    if (/not associated with any ads accounts/i.test(nestedMessage)) {
      return codeMessages.GOOGLE_ADS_NO_ACCOUNT;
    }
    if (/invalid redirect_uri/i.test(nestedMessage)) {
      const redirectUri = getOAuthRedirectUri();
      return redirectUri
        ? `Invalid redirect URL. Add this exact URL in your platform OAuth settings: ${redirectUri}`
        : nestedMessage;
    }
    if (/url blocked|not white-listed/i.test(nestedMessage)) {
      return nestedMessage;
    }
    return nestedMessage;
  }

  if (typeof error?.error === 'string' && error.error.trim()) {
    if (/failed to fetch|network error|load failed/i.test(error.error)) {
      return codeMessages.NETWORK_ERROR;
    }
    return error.error;
  }

  return error?.error_description || error?.message || fallback;
};
